import { render, staticRenderFns } from "./ExternalProviders.vue?vue&type=template&id=2d06993a&"
import script from "./ExternalProviders.vue?vue&type=script&lang=js&"
export * from "./ExternalProviders.vue?vue&type=script&lang=js&"
import style0 from "./ExternalProviders.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports